<div class="list-item"  [ngClass]="{'on-preview': displayed}">

    <div class="details">
        <span class="title" (click)="actionClick.emit(file)">{{file.name}}</span>
        <span class="download-icon" title="Download" (click)="actionDownloadClick(file,$event)"></span>
        <span class="size">({{file.filesize}})</span>
        <span class="ext">{{file.extension}}</span>
        <core-helpers-icons-notes-counter-bubble
            *ngIf="notes != 0 && notes != null"
            [title]= "notes+' notes'"
            [letter]="notes"
            (actionClick)="actionClick.emit(file)"
        ></core-helpers-icons-notes-counter-bubble>
    </div>
    
    <core-helpers-navigation-three-dots-menu [menu]="menu" (action)="onMenuSelect($event)"></core-helpers-navigation-three-dots-menu>

</div>
    